import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {IExgTab} from 'exc-tab-v2';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgDataListComponent, ExgModalService, ExgTableSettingsComponent} from 'exc-controls-v2';
import {EnumerationService} from '../../../services/enumeration.service';

@Component({
  selector: 'app-tab-settings-autotext',
  templateUrl: './tab-settings-autotext.component.html',
  styles: []
})
export class TabSettingsAutotextComponent extends ExcTranslation implements IExgTab, OnInit {
  @ViewChild('VCTBList', {read: ExgDataListComponent}) VCTBList!: ExgDataListComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;

  Data: any;
  tabinstance: any;

  TBList = {
    selectKey: 'tbID',
    state: 1,
    selectedRow: undefined as any,
    prefilter_DEL: 0,
    searchValue: '',
    data: [] as any [],
    dataPlaceholder: [] as any[],
    distinctData: [] as any[],
    tableDefinition: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    isLoading: true,
    selectionChanged: (index: any) => {
      this.TBList.selectedRow = this.TBList.data[index];
    },
    pageChanged: (page: number) => {
      if (this.TBList.MetaInfo.dataPaging !== undefined) {
        this.TBList.MetaInfo.dataPaging.pageNo = page;
      }
      this.loadTBData();
    },
    search: (value: string) => {
      this.TBList.searchValue = value;
      this.TBList.pageChanged(0);
      this.loadTBData();
    },
    ready: () => {
      if (this.TBList.data.length === 0) {
        this.TBList.state = 2;
        this.VCTBList.selectedRow = -1;
      }  else {
        this.TBList.state = 0;
        this.VCTBList.selectedRow = 0;
      }
      this.TBList.isLoading = false;
    },
    loadData: (incomingData: any, incomingPaging: any) => {
      this.TBList.isLoading = false;
      this.TBList.data = incomingData;
      this.TBList.paging = incomingPaging;
      this.TBList.ready();
    },
    loadDataPlaceholder: (incomingData: any) => {
      this.TBList.dataPlaceholder = incomingData;
    },
    getDistinctData: (dataDistinct: IExcDataDistinct) => {
      this.TBList.MetaInfo.dataDistinct = dataDistinct;
      this.excRestService
        .sget(
          this.excRestService.computeUrl('TextbausteinR_List', {
            fts: this.TBList?.searchValue,
            mode: this.Data.mode
          }),
          ExcCoreModule.Guid.NewGuid(),
          {MetaInfo: this.TBList.MetaInfo}
        ).subscribe((ret: any) => {
        this.TBList.distinctData = ret.data;
      });
    }
  };
  MCEinit: any = {
    placeholder: '',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,

    plugins: ['table', 'paste'],

    valid_styles: {
      '*': 'font-weight,font-style,text-decoration,text-align,color,background-color'
    },

    // beim Paste alle font-family/size hart entfernen
    paste_preprocess: (plugin: any, args: any) => {
      // args.content ist ein HTML-String
      args.content = args.content
        .replace(/font-family\s*:\s*[^;"']+;?/gi, '')
        .replace(/font-size\s*:\s*[^;"']+;?/gi, '')
        .replace(/<font[^>]*>/gi, '')
        .replace(/<\/font>/gi, '');
    },
    content_style:
      '@import url(\'https://fonts.googleapis.com/css?family=Calibri\'); body { font-family: Calibri; font-size: 11pt; }',

    toolbar:
      'table | bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons',
    table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
    contextmenu: 'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor | table | EXAKTFieldInsert EXAKTTextblockInsert',
    setup: (editor: any) => {
      editor.ui.registry.addNestedMenuItem('EXAKTFieldInsert', {
        text: 'Feld einfügen',
        getSubmenuItems: () => {
          const rtVal: any[] = [];
          for (const dataPlaceholderElement of this.TBList.dataPlaceholder) {
            rtVal.push({
              type: 'menuitem',
              text:
                dataPlaceholderElement.caption.startsWith('vorg') || dataPlaceholderElement.caption.startsWith('au') ?
                  this.enumSvc.getFieldCaption(
                    dataPlaceholderElement.caption.startsWith('vorg') ? 'Vorgang' : dataPlaceholderElement.caption.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag',
                    dataPlaceholderElement.caption) : dataPlaceholderElement.caption,
              onAction: () => {
                editor.insertContent(dataPlaceholderElement.placeholder);
              }
            });
          }

          return rtVal;
        }
      });
    }
  };
  editor = {
    mode: '',
    oeList: [] as any[],
    oeGetIndexOf: (oeID: any): number => {
      return this.editor.oeList.findIndex((oe: any) => oe.oeID === oeID);
    },
    oeSelectionChange: ($event: number, row: any): void => {
      row.tb_oeIDClone = this.editor.oeList.find((oe: any, index) => index === $event)?.oeID;
      console.log(row.tb_oeIDClone);
    },
    enmList: [] as any[],
    enmName: '',
    enmTable: '',
    save: (row: any): void => {
      this.excRestService.put(
        this.excRestService.computeUrl('TextbausteinU', {tbID: row.tbID})
        , {
          tbUPT: row.tbUPT
          , tbName: row.tbNameClone
          , mode: this.Data.mode
          , tbText: row.tbTextClone
          , tbTextShort: row.tbTextShortClone
          , tb_oeID: row.tb_oeIDClone
          , tb_enmIdent_Typ: row.tb_enmIdent_TypClone
        }
      ).subscribe((result: any) => {
        if (result.data && result.success) {
          this.modalSrv
            .showToast('Erfolgreich gespeichert'
              , 'md-toast bg-green'
              , 'far fa-check');
        } else {
          this.modalSrv
            .showToast('Speichern Fehlgeschlagen'
              , 'md-toast bg-red'
              , 'far fa-cross');
        }
        this.loadTBData();
      });
    },
    delete: (row: any): void => {
      this.excRestService.delete(
        this.excRestService.computeUrl('TextbausteinD', {tbID: row.tbID})
      ).subscribe((result: any) => {
        if (result.data && result.success) {
          this.modalSrv
            .showToast('Erfolgreich gelöscht'
              , 'md-toast bg-green'
              , 'far fa-check');
          this.loadTBData();
        }
      });
    },
  };

  constructor(
    private excRestService: ExcRestService,
    public enumSvc: EnumerationService,
    private modalSrv: ExgModalService
  ) {
    super();
  }

  ngOnInit(): void {
    this.tabinstance.Label =
      this.getRessource('Label', {
        mode: this.Data.mode === 'CASE' ? 'Auftrag' : 'Vorgang'
      });
    this.initEditor();
    this.initTableDefinition();
    this.loadTBData();
  }

  initEditor(): void {
    if (this.Data.mode === 'CASE') {
      this.editor.enmTable = 'Auftrag';
      this.editor.enmName = 'AuftragTyp';
    } else {
      this.editor.enmTable = 'Vorgang';
      this.editor.enmName = 'VorgangTyp';
    }
    this.editor.enmList.push({
      enmName: this.editor.enmName,
      enmIdent: 0,
      enmText: '- nichts ausgewählt -',
      enmTextA: '- nichts ausgewählt -',
      enmSelector: '',
      enmSort: 0,
      enmDefault: true,
      enmVFR: 1451606400000,
      enmVTO: 2713910400000
    });

    for (const enumeration of this.enumSvc.getEnumerationList(this.editor.enmName)) {
      this.editor.enmList.push(enumeration);
    }

    this.editor.mode = this.Data.mode;
  }

  initTableDefinition(): void {
    this.TBList.tableDefinition = [
      {
        caption: this.getRessource('oeNameShort')
        , value: 'oeNameShort'
        , fixed: false
        , align: 0
        , sort: 0
        , ordinal: 0
        , visible: true
      },
      {
        caption: this.getRessource('oeName')
        , value: 'oeName'
        , fixed: false
        , align: 0
        , sort: 0
        , ordinal: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption(this.editor.enmTable, this.editor.enmName)
        , value: 'tb_enmIdent_Typ'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return value > 0 ? this.enumSvc.getEnumerationText(this.editor.enmName, value) : '- nichts ausgewählt -';
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Textbaustein', 'tbName')
        , value: 'tbName'
        , fixed: false
        , align: 0
        , sort: 0
        , ordinal: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Textbaustein', 'tbTextShort')
        , value: 'tbTextShort'
        , fixed: false
        , align: 0
        , sort: 0
        , ordinal: 0
        , visible: true
      },
    ];
  }

  openTableSettings($event: any): void {
    this.VCtableDefinitionSettings.openFilterConfig($event);
  }

  openCreateModal(): void {
    this.modalSrv
      .show('ModalNewSettingsAutotextComponent', {
        dataPlaceholder: this.TBList.dataPlaceholder,
        editor: this.editor
      }).subscribe((retValue: any) => {
        if (retValue) {
          this.excRestService.post(
            this.excRestService.computeUrl('TextbausteinC', {mode: this.Data.mode}),
            retValue
          ).subscribe((result: any) => {
            if (result.data && result.success) {
              this.modalSrv
                .showToast('Erfolgreich erstellt'
                  , 'md-toast bg-green'
                  , 'far fa-check');
              this.loadTBData();
            }
          });
        }
    });
  }

  loadTBData(): void {
    this.TBList.state = 1;
    this.TBList.isLoading = true;
    this.excRestService
      .get(
        this.excRestService.computeUrl('TextbausteinR_List', {
          fts: this.TBList?.searchValue,
          mode: this.Data.mode
        }),
        {
          MetaInfo: {
            dataPaging: this.TBList.MetaInfo.dataPaging,
            dataSort: this.TBList.MetaInfo.dataSort,
            dataFilter: this.TBList.MetaInfo.dataFilter
          }
        })
      .subscribe(
        (data: any) => {
          if (data && data.success) {
            this.editor.oeList = data.data.OE;
            this.TBList.loadDataPlaceholder(data.data.Placeholder);
            this.TBList.loadData(data.data.Textbaustein, data.paging.Textbaustein);
          }
        }
      );
  }
}
